import React from 'react';

import Checkbox from '../../../../library/checkbox/checkbox';
import Image from '../../../../library/image/image';
import Tooltip from '../../../../library/tooltip/tooltip';

import { CmsToolTipsComponent } from '../../../../shared/types/graphql-types';

import './treadwell-checkbox.scss';

interface TreadwellCheckboxProps {
  checkboxItems: CmsToolTipsComponent;
  isChecked: boolean;
  onClick: () => void;
}

function TreadwellCheckbox(props: TreadwellCheckboxProps) {
  const { checkboxItems, isChecked, onClick } = props;
  const { description, icon, id, name } = checkboxItems;

  if (!name || !icon) {
    return null;
  }

  return (
    <div styleName="checkbox-wrapper">
      <Checkbox
        id="treadwell-checkbox"
        isChecked={isChecked}
        label={name}
        onClick={onClick}
        styleName="treadwell-checkbox"
      />
      <Tooltip content={description} styleName="tooltip" />
      {icon && id && (
        <div styleName="treadwell-checkbox-icon">
          <Image alt={id} src={icon} />
        </div>
      )}
    </div>
  );
}

export default TreadwellCheckbox;
